import type { IMetaTemplate, MetaTemplateStatus } from './meta-wpp-template.service';
import { seloDaCategoria } from './template-categories';

/**
 * Regras de edição e de reclassificação de template Meta, compartilhadas pela gestão de
 * templates, pelo formulário e pelos seletores de envio. Espelham o server
 * (`meta-templates.service.ts`), que continua sendo quem decide.
 */

/** Status em que a Meta aceita editar o conteúdo. Fora deles o template só é VISUALIZADO. */
export const STATUS_EDITAVEIS: MetaTemplateStatus[] = ['APPROVED', 'REJECTED', 'PAUSED'];

export const podeEditarTemplateMeta = (status?: MetaTemplateStatus | null): boolean =>
    !!status && STATUS_EDITAVEIS.includes(status);

/** Template aprovado (pausado é um aprovado suspenso) não troca de categoria na Meta. */
export const categoriaTravadaNoStatus = (status?: MetaTemplateStatus | null): boolean =>
    status === 'APPROVED' || status === 'PAUSED';

/** Por que o formulário abriu só para leitura — o aviso no topo dele. */
export function motivoSomenteLeitura(status?: MetaTemplateStatus | null): string {
    switch (status) {
        case 'PENDING':
            return 'Este template está em análise pela Meta. Enquanto a análise não termina, a Meta não aceita edições — por isso os campos estão bloqueados. Assim que for aprovado ou rejeitado, você poderá editá-lo.';
        case 'IN_APPEAL':
            return 'Este template está em recurso (revisão solicitada) na Meta. Enquanto o recurso não é julgado, ele não pode ser editado.';
        case 'PENDING_DELETION':
        case 'DELETED':
            return 'Este template foi excluído (ou está sendo excluído) na Meta e não pode mais ser editado.';
        case 'DISABLED':
        case 'LIMIT_EXCEEDED':
            return 'A Meta desabilitou este template e não aceita edições nele. Crie um novo template se precisar de outra versão.';
        case 'LOCKED':
            return 'A Meta trancou este template: ele não aceita edições.';
        case 'ARCHIVED':
            return 'Este template está arquivado na Meta e não pode ser editado.';
        default:
            return 'O status atual deste template na Meta não permite edição — você pode apenas visualizá-lo.';
    }
}

// ===== Reclassificação =====

export const rotuloCategoria = (categoria?: string | null): string =>
    seloDaCategoria(categoria)?.label ?? categoria ?? 'desconhecida';

type ComCategorias = Pick<IMetaTemplate, 'category' | 'categoriaSolicitada' | 'reclassificado'>;

/** A Meta aprovou com categoria diferente da pedida. */
export const ehReclassificado = (t?: ComCategorias | null): boolean =>
    !!t && (t.reclassificado ?? (!!t.categoriaSolicitada && t.categoriaSolicitada !== t.category));

export const descricaoReclassificacao = (t: ComCategorias): string =>
    `Pedido como ${rotuloCategoria(t.categoriaSolicitada)}, aprovado pela Meta como ${rotuloCategoria(t.category)}. `
    + `Cada envio é cobrado como ${rotuloCategoria(t.category)}.`;

